export default {
  campaignsBudgets: null,
  campaignsBudgetsDownloads: null,
};
